/**
 * browser-loop — public surface.
 *
 * Three legitimate import paths from outside the library:
 *
 *   import { BrowserLoopProvider } from '@/shared/lib/browser-loop';
 *     → mount once at app/(app)/layout.tsx
 *
 *   import { emit, BROWSER_EVENT_KIND } from '@/shared/lib/browser-loop';
 *     → for ErrorBoundary integration and any explicit emit (rare).
 *     Most events flow through the patches, not explicit emits.
 *
 *   import { readToken, writeToken, clearToken } from '@/shared/lib/browser-loop';
 *     → for the /admin/dev-loop activation page.
 *
 * Everything else (patches, transport, sampling, scrub, identity,
 * traceparent, client) is internal. Don't import them from outside the
 * library — the patches install themselves via the provider; nothing
 * external needs the lower-level surfaces.
 */

export { BrowserLoopProvider } from "./provider";
export { emit, getClient } from "./client";
export { BROWSER_EVENT_KIND, SEVERITY } from "./kinds";
export type { BrowserEventKind, BrowserSeverity } from "./kinds";
export { readToken, writeToken, clearToken } from "./config";
export type { BrowserLoopMode } from "./config";
